<template>
  <div class="function-features">
    <div class="contaner">
      <h2 class="title">{{ title }}</h2>
      <div class="content">
        <!-- 左侧标签页 -->
        <ul class="tabs">
          <li
            v-for="(tab, index) in tabs"
            :key="index"
            :class="{ active: activeTab === index }"
            @click="handleTabClick(tab, index)"
          >
            {{ tab }}
          </li>
        </ul>

        <!-- 右侧内容 -->
        <div class="details">
          <div
            class="background"
            :style="{ backgroundImage: `url(${backgroundImage})` }"
            v-if="backgroundImage"
          >
            <div class="overlay">
              <ul>
                <li v-for="(item, index) in tabContents" :key="index">
                  <h3>{{ item.name }}</h3>
                  <p v-html="formatContent(item.content)"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productGetById } from "@/api/dataManeger.js";
import eventBus from "@/eventBus"; // 新增：引入事件总线
export default {
  name: "FunctionFeatures",
  data() {
    return {
      tabs: ["数字化", "无人化", "智能化", "集群化", "协同化", "定制化"], // 默认标签
      activeTab: 0,
      totalData: [],
      tabContents: [
        {
          name: "全流程数据管理",
          content: "支持飞行数据、业务数据本地化存储与集中管理...",
        },
        { name: "三维可视化建模", content: "集成高精度三维点云与实景模型..." },
        {
          name: "多源数据融合",
          content: "实时整合视频流、设备状态、地理信息等多维度数据...",
        },
      ], // 默认内容
      currentSource: "",
      title: "系列特点", // 新增的动态标题字段
      backgroundImage: "", // 默认背景图
    };
  },
  watch: {
    "$route.fullPath": {
      immediate: true,
      handler() {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("source");
        this.currentSource = source;
        this.backgroundImage = "";
        // 动态设置标题
        if (source === "product_lie_11" || source === "product_lie_12") {
          this.title = "功能特点";
        } else {
          this.title = "系列特点";
        }
        const proBy1Type = urlParams.get("proBy1Type");
        this.getproductDetail();
      },
    },
  },
  mounted() {
    this.getproductDetail();
    // 新增：监听事件总线
    eventBus.$on("change-tab", this.getproductDetail);
  },
  // beforeDestroy() {
  //   // 新增：移除监听
  //   eventBus.$off('change-tab', this.getproductDetail);
  // },
  methods: {
    async getproductDetail() {
      this.activeTab = 0;
      let name = localStorage.getItem("TeDianBgProName");
      if (
        name == "ZF-E2000-Q AIBOX车（船）载智能大脑" ||
        name == "ZF-D2000-Q AIBOX车（船）载智能大脑" ||
        name == "ZF-3588车（船）载智能大脑"
      ) {
        name = "车（船）载智能大（小）脑";
      }

      if (name == "空海一体智能无人艇") {
        name = "水上智能航空站";
      }
      productGetById({ name: name }).then((res) => {
        if (res) {
          this.totalData = res.result.elementJsonArray;
     
          this.backgroundImage = res.result.elementJsonArray[0].img;
          this.tabs = this.totalData.map((item) => item.name);
          this.tabContents = res.result.elementJsonArray[0].child;
        }
      });
    },
    handleTabClick(tab, index) {
      this.activeTab = index;
      // 新增：根据tab名称匹配totalData中的数据
      if (this.totalData && this.totalData.length > 0) {
        const match = this.totalData.find((item) => item.name === tab);
        if (match) {
          this.backgroundImage = match.img;
          this.tabContents = match.child;
          return;
        }
      }
    },
    // 新增：changeTab方法
    changeTab(tab) {
      const index = this.tabs.indexOf(tab);
      if (index !== -1) {
        this.handleTabClick(tab, index);
      }
    },
    formatContent(content) {
      if (!content) return "";
      // 兼容 \n、\\n、\r\n
      return String(content).replace(/\\n|(\r\n)|\n/g, "<br>");
    },
  },
};
</script>

<style scoped lang="scss">
.function-features {
  padding: 20px;
  font-family: Arial, sans-serif;
  padding: 0px 0px 80px;

  background: url("../../assets/home/gongTe.png") no-repeat;
  background-size: 100% 100%;
}

.contaner {
  width: 1200px;
  margin: 0 auto;
}

.title {
  font-family: PingFang SC;
  font-size: 32px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0px;

  font-variation-settings: "opsz" auto;
  color: #1e242a;
  padding: 80px 0px 40px;
  text-align: center;
}

.content {
  display: flex;
}

.tabs {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-right: 20px;
  border-radius: 8px;
  background: linear-gradient(180deg, #f4f6f9 0%, #ffffff 100%);
  border: 1px solid #ffffff;
  padding-top: 20px;
  width: 240px;
}

.tabs li {
  padding-left: 40px;
  padding-right: 50px;
  cursor: pointer;
  /* background: white; */
  color: #1e242acc;
  border-left: 2px solid transparent;
  transition: all 0.3s;
  width: 238px;
  /* 自适应宽度，1920分辨率下约为240PX */
  height: 80px;
  /* 自适应高度，1920分辨率下约为80PX */
  display: flex;
  align-items: center;
  justify-content: left;
  box-sizing: border-box;
  font-size: 18px;
  &:hover {
    background: linear-gradient(
      108deg,
      rgba(15, 107, 246, 0.1) 0%,
      rgba(15, 107, 246, 0) 70%
    );
  }
}

.tabs li.active {
  /* background: linear-gradient(to right, #4a90e2, #007aff); */
  background: linear-gradient(
    108deg,
    rgba(15, 107, 246, 0.1) 0%,
    rgba(15, 107, 246, 0) 100%
  );
  color: #0f6bf6;
  border-left: 2px solid #007aff;
  font-weight: bold;
}

.details {
  width: calc(100% - 260px);
  position: relative;
}

.background {
  height: 520px;
  position: relative;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  /* 新增的样式 */
}

.overlay {
  background: linear-gradient(
    120deg,
    rgba(30, 36, 42, 0.8) 0%,
    rgba(30, 36, 42, 0) 97%
  );
  color: white;
  padding: 40px;
  height: 100%;
  border-radius: 8px;
  /* 新增的样式 */
}

.overlay ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.overlay li {
  margin-bottom: 24px;
}

.overlay h3 {
  font-size: 16px;
  margin: 0 0 12px;
}

.overlay p {
  font-size: 14px;
  margin: 0;
  opacity: 0.8;
  word-break: break-all;
}
</style>
